import { useEffect } from "react";
import { connect } from "react-redux";
import { Empty, PageHeader } from "antd";

import { setRoute } from "scripts/reducer";
import Resources from "scripts/resources";

const Component = ({ onSetRoute, routeName, parentName }) => {
  const componentDidMount = () => {
    onSetRoute({ openKey: parentName, selectedKey: routeName });
  };

  useEffect(componentDidMount, []);

  return (
    <>
      <PageHeader title={Resources.dashboard} />
      <Empty />
    </>
  );
};

export default connect(null, (dispatch) => {
  return {
    onSetRoute: (data) => dispatch(setRoute(data)),
  };
})(Component);
